import {
  MyAccountThemeProvider,
  usePlatformConfig,
  useWidgetContext,
  toggleDataLayer,
  dataLayerInitializationHandler,
  dataLayerPriceDisplay,
  PreviewModeBanner,
  CurrencyContextProvider,
} from '@dxp-module/common'
import WidgetRouter from './WidgetRouter'
import MiniMyAccountComponent from './miniWidget/components/containers/MiniMyAccountComponent'

const WidgetContent = () => {
  const {
    configuration: { dimensions },
  } = useWidgetContext()
  const { platformConfig } = usePlatformConfig()

  if (platformConfig.dataLayer) {
    toggleDataLayer.set(dimensions, true)
    dataLayerPriceDisplay.set(dimensions, platformConfig.priceDisplay)
  }

  dataLayerInitializationHandler(dimensions)

  return (
    <MyAccountThemeProvider themeOverride={platformConfig.themeOverride}>
      <PreviewModeBanner translationId="trans__myaccount__headers__preview_header" />
      <MiniMyAccountComponent />
      <CurrencyContextProvider>
        <WidgetRouter />
      </CurrencyContextProvider>
    </MyAccountThemeProvider>
  )
}

export default WidgetContent
